// src/services/authService.js
import { doc, setDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db, auth } from '../firebase/config';
import { 
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth';

// 로그인 함수
export const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    throw new Error('로그인에 실패했습니다: ' + error.message);
  }
};

// 회원가입 함수
export const register = async (userData) => {
  try {
    const { email, name, phone } = userData;

    // Firestore에서 이메일 중복 확인
    const usersRef = collection(db, 'users');
    const q = query(usersRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      throw new Error('이미 등록된 이메일입니다.');
    }

    // Firestore에 사용자 정보 저장
    const newUserRef = doc(usersRef);
    await setDoc(newUserRef, {
      name,
      phone,
      email,
      createdAt: new Date()
    });

    return { id: newUserRef.id, ...userData };
  } catch (error) {
    throw new Error('회원가입에 실패했습니다: ' + error.message);
  }
};

// 로그아웃 함수
export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    throw new Error('로그아웃에 실패했습니다: ' + error.message);
  }
};